<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="600px"
  (onClose)="onClose()"
>
  <div slot="children">
    <xi-basic-tile
      [hasTopBar]="false"
      [stretch]="true"
      [isInteractive]="false"
      class="smart-summary__basic-tile"
    >
      <div slot="children">
        <div
          *transloco="let t; read: 'widgets.smart-summary'"
          class="xi-modal__container smart-summary__container"
        >
          <h2 class="xi-modal__title">{{ t('smart-summary') }}</h2>

          <div class="xi-modal__content">
            @if (taskCreated) {
              <div class="smart_summary__task-created">
                <mat-icon svgIcon="downloading" class="smart_summary__downloading-icon"></mat-icon>
                <div class="smart_summary__task-created-title">
                  {{ t('document-being-created') }}
                </div>
                <div>
                  {{ t('download-center-prefix') }}
                  <strong>
                    <a #downloadCenterLink (click)="onOpenDownloadCenter(downloadCenterLink)">{{
                      t('download-center')
                    }}</a>
                  </strong>
                  {{ t('download-center-suffix') }}
                </div>
              </div>
            } @else {
              <ng-container [formGroup]="formGroup">
                <div class="smart-summary__field">
                  <div class="smart-summary__field-label">{{ t('breakdown-field') }}</div>
                  <div class="smart-summary__input-field">
                    <xi-input-field formControlName="breakdownField" required [stretch]="true">
                    </xi-input-field>
                  </div>
                </div>
                <div class="smart-summary__field">
                  <div class="smart-summary__field-label">{{ t('driver') }}</div>
                  <div class="smart-summary__input-field">
                    <xi-input-field formControlName="driver" required [stretch]="true">
                    </xi-input-field>
                  </div>
                </div>
                @if (data.hasAnalyticItem) {
                  <div class="smart-summary__field">
                    <div class="smart-summary__field-label">{{ t('analytic-item') }}</div>
                    <div class="smart-summary__input-field">
                      <xi-input-field formControlName="analyticItemName" [stretch]="true">
                      </xi-input-field>
                    </div>
                  </div>
                }
                <div class="smart-summary__field">
                  <div class="smart-summary__field-label">{{ t('length') }}</div>
                  <div class="smart-summary__input-set">
                    <app-lex-horizontal-stepper
                      [(value)]="length"
                      [scale]="lengthScale"
                    ></app-lex-horizontal-stepper>
                    <div>{{ t('paragraphs', { count: lengthScale.max }) }}</div>
                  </div>
                </div>
                <div class="smart-summary__field">
                  <div class="smart-summary__field-label">{{ t('style') }}</div>
                  <div class="smart-summary__input-set">
                    @for (radio of styleRadios; track radio; let i = $index) {
                      <xi-radio
                        [value]="radio.value"
                        [label]="radio.label"
                        name="styleRadio"
                        formControlName="style"
                      ></xi-radio>
                    }
                  </div>
                </div>
                <div class="smart-summary__field">
                  <div class="smart-summary__field-label">{{ t('language') }}</div>
                  <div class="smart-summary__input-field">
                    <xi-dropdown
                      formControlName="language"
                      name="language"
                      [data]="languageOptions"
                      [stretch]="true"
                    ></xi-dropdown>
                  </div>
                </div>
              </ng-container>
            }
          </div>

          <div class="xi-modal__actions smart-summary__actions">
            @if (taskCreated) {
              <div></div>
              <xi-default-button [text]="t('got-it')" (onClick)="onClose()"></xi-default-button>
            } @else {
              <xi-default-button
                type="button"
                [text]="t('cancel')"
                fill="text"
                (onClick)="onClose()"
              ></xi-default-button>
              @if (taskCreationInProgress) {
                <div>
                  <xi-animation
                    [height]="75"
                    [width]="75"
                    [loop]="true"
                    animation="cx_loader"
                  ></xi-animation>
                </div>
              }
              <xi-default-button
                [text]="t('summarize')"
                [disabled]="taskCreationInProgress || formGroup.invalid"
                (onClick)="onSummarize()"
              ></xi-default-button>
            }
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
